import React, { useState, useEffect } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import ToolkitProvider, {
  // Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";

// const { SearchBar } = Search;

import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

// import moment from "moment/min/moment-with-locales";
import moment from "moment";
import "moment/locale/th";

moment.locale("th");

import { Row, Col } from "react-bootstrap";
// Import Service
import RegsugarService from "../../services/regsugar.service";
// import OcsbService from "../../services/ocsb.service";
import authService from "../../services/auth.service";
import TimeregService from "../../services/timereg.service";

//Import Modal
import Modalapprove from "./Modalapprove";
// import ModalContract from "./ModalContract";
import ModalViewApprove from "./ModalViewApprove";
// import ModalResign from "./Modalresign";

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";

//import DownloadPDF
import DownloadPDF from "./DownloadPdf";

// import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// import Tooltip from "react-bootstrap/Tooltip";
// const renderTooltip = (props) => {
//   return <Tooltip {...props}>คลิ๊ก Sign บัตรใหม่</Tooltip>;
// };

const Approvelist = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  // const [showResign, setShowResign] = useState(false);
  const [farmerselectView, farmerSetselectView] = useState({});
  const [showView, setShowView] = useState(false);
  // const [membertype, setMembertype] = useState();
  // const [showContract, setShowContract] = useState(false);
  const [farmerselect, farmerSetselect] = useState({});

  const [currentTimeReg, setCurrentTimeReg] = useState({});

  // const [timeregList, setTimeregList] = useState([]);
  // const [timeregSelect, setTimeregSelect] = useState(0);

  const user = authService.getCurrentUser();

  const { ExportCSVButton } = CSVExport;

  // const handleTimeregChange = (e) => {
  //   setTimeregSelect(e.target.value);
  //   getData(user.user.user_reg, e.target.value);
  // };
  // const getTimeRegList = () => {
  //   TimeregService.getTimereglist(user.user.user_reg)
  //     .then((response) => {
  //       setTimeregList(response.data.data);
  //     })
  //     .catch((err) => {
  //       console.log("fetch timereg List Error :" + err);
  //     });
  // };

  useEffect(() => {
    checkTimereg();
  }, []);

  const checkTimereg = () => {
    TimeregService.getLastCurrent()
      .then((response) => {
        if (response.data.success && response.data.data !== null) {
          setCurrentTimeReg(response.data.data);
          getData(user.user.user_reg, response.data.data.timereg_id);
        } else {
          setCurrentTimeReg({ message: "ไม่มีรอบให้จดทะเบียน" });
        }
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
      });
  };

  const getData = (user_reg, timereg_id) => {
    setLoading(true);
    RegsugarService.getRegsugarlistForRegistrar(user_reg, timereg_id)
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const showCSVButton = (prop) => {
    if (user.user.member_type === 5) {
      return (
        <ExportCSVButton
          {...prop.csvProps}
          style={{
            padding: ".375rem .75rem",
            fontSize: "1rem",
            float: "right",
          }}
        >
          <i className="bi bi-download"></i>
        </ExportCSVButton>
      );
    } else if (user.user.member_type === 6) {
      return "";
    }
  };
  const clickViewApprove = (row) => {
    farmerSetselectView({
      regsugar_id: row.regsugar_id,
      person_card_id: row.person_card_id,
      approve_status: row.approve_status,
    });
    setShowView(true);
  };

  const clickApprove = (row) => {
    farmerSetselect({
      regsugar_id: row.regsugar_id,
      person_card_id: row.person_card_id,
      approve_status: row.approve_status,
    });
    setShow(true);
  };
  // const clickResign = (row) => {
  //   farmerSetselect({
  //     regsugar_id: row.regsugar_id,
  //     person_card_id: row.person_card_id,
  //     approve_status: row.approve_status,
  //     farmer_name: row.farmer_name,
  //   });
  //   setShowResign(true);
  // };

  // const clickContract = (row) => {
  //   farmerSetselect({
  //     regsugar_id: row.regsugar_id,
  //     person_card_id: row.person_card_id,
  //     approve_status: row.approve_status,
  //   });
  //   setShowContract(true);
  // };

  const ActionsEdit = (row) => {
    return (
      <>
        {/* <i
          className="bi bi-search custom-icon-table"
          onClick={() => clickContract(row.row)}
        ></i> */}
        {row.row.approve_status == "อนุมัติ" ||
        row.row.approve_status == "ไม่อนุมัติ" ? (
          <i
            className="bi bi-search custom-icon-table"
            onClick={() => clickViewApprove(row.row)}
          ></i>
        ) : (
          <i
            className="bi bi-pencil custom-icon-table"
            onClick={() => clickApprove(row.row)}
          ></i>
        )}
        {row.row.farmer_card_id != "-" ? (
          <div>
            <DownloadPDF
              card={row.row.farmer_card_id}
              idno={row.row.person_card_id}
            />
            {/* <OverlayTrigger placement="top" overlay={renderTooltip}>
              <i
                className="bi bi-pencil-square custom-icon-table"
                onClick={() => clickResign(row.row)}
              ></i>
            </OverlayTrigger> */}
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  const actionsEditFormatter = (cell, row) => {
    return <ActionsEdit row={row} />;
  };

  const columns = [
    {
      text: "regsugar_id",
      dataField: "regsugar_id",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "person_card_id",
      dataField: "person_card_id",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "ชื่อ-สกุล",
      dataField: "farmer_name",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "left",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "สร้างโดย",
      dataField: "user_create",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "ชาวไร่",
      dataField: "status",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "8%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      // style: {
      //   wordBreak: "break-word",
      // },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "ผลการพิจารณา",
      dataField: "approve_status",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "8%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "อนุมัติโดย",
      dataField: "approver_name",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "เลขชาวไร่",
      dataField: "person_card_id",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "เริ่ม",
      dataField: "start_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      searchable: false,
      formatter: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "8%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "สิ้นสุด",
      dataField: "end_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      searchable: false,
      formatter: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "8%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "หมายเหตุ",
      dataField: "comment",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "แก้ไข",
      dataField: "edit",
      isDummyField: true,
      editable: false,
      formatter: actionsEditFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  if (error) return `Error :${error}`;

  return (
    <div>
      {loading ? <LoadingAlert /> : ""}
      {/* <ModalContract
        show={showContract}
        hidden={setShowContract}
        farmerselect={farmerselect}
      /> */}
      {/* <ModalResign
        show={showResign}
        hidden={setShowResign}
        farmerselect={farmerselect}
      /> */}
      <Modalapprove
        show={show}
        hidden={setShow}
        farmerselect={farmerselect}
        setdata={setData}
      />
      <ModalViewApprove
        show={showView}
        hidden={setShowView}
        farmerselect={farmerselectView}
        setdata={setData}
      />
      <ToolkitProvider
        bootstrap4
        keyField="regsugar_id"
        data={data}
        columns={columns}
        search
        exportCSV={{
          fileName: "assoc_summary.csv",
          separator: ",",
          ignoreHeader: false,
          noAutoBOM: true,
          blobType: "text/csv;charset=UTF-8",
          onlyExportFiltered: true,
          exportAll: false,
        }}
      >
        {(prop) => (
          <React.Fragment>
            <Row>
              <Col md={6}>
                {currentTimeReg.message ? (
                  <>
                    <span>{currentTimeReg.message}</span>
                  </>
                ) : (
                  <>
                    <span style={{ fontWeight: "bold" }}>
                      {currentTimeReg.timereg_desc}
                    </span>
                    <span>{" เริ่มวันที่ "}</span>
                    <span>
                      {moment(currentTimeReg.timereg_start)
                        .add(543, "year")
                        .locale("th")
                        .format("ll")}
                    </span>
                    <span>{" ถึงวันที่ "}</span>
                    <span>
                      {moment(currentTimeReg.timereg_stop)
                        .add(543, "year")
                        .locale("th")
                        .format("ll")}
                    </span>
                  </>
                )}
              </Col>
              <Col md={6}>
                <div>
                  <div className="text-left">
                    {/* <SearchBar {...prop.searchProps} /> */}
                    {showCSVButton(prop)}
                  </div>
                </div>
              </Col>
            </Row>

            <hr />
            <BootstrapTable
              // bootstrap4
              // keyField="farmer_id"
              // columns={columns}
              // data={data}
              pagination={pagination}
              //   cellEdit={cellEditFactory({
              //     mode: "click",
              //     blurToSave: true,
              //     afterSaveCell,
              //   })}
              filter={filterFactory()}
              // loading={true}
              {...prop.baseProps}
              // cellEdit={cellEditFactory({
              //   mode: "click",
              //   blurToSave: true,
              //   afterSaveCell: handleChange,
              //   beforeSaveCell: beforeSaveCell,
              // })}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default Approvelist;
